export default {
  namespaced: true,

  state: {
    brokerCommissionsList: [],
    brokerCommissionsData: {},
    editItem: null,
    isLoading: false,
    error: null
  },
  getters: {
    brokerCommissionsList(state) {
      return state.brokerCommissionsList
    },
    brokerCommissionsData(state) {
      return state.brokerCommissionsData
    },
    editItem(state) {
      // console.log(state.editItem)
      return state.editItem
    },
    isLoading(state) {
      return state.isLoading
    },
    error(state) {
      return state.error
    },
  },
  mutations: {
    SET_BROKER_COMMISSIONS(state, brokerCommissionsList) {
      state.brokerCommissionsList = brokerCommissionsList 
      console.log(state.brokerCommissionsList)

    },
    SET_BROKER_COMMISSION_DATA(state, brokerCommissionsData) {
      state.brokerCommissionsData = brokerCommissionsData
    },
    GET_BROKER_COMMISSION(state, index) {
      let editItemIndex = state.brokerCommissionsList.map(function(item) { return item.id; }).indexOf(parseInt(index));
      state.editItem = state.brokerCommissionsList[editItemIndex]
    },
    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    REMOVE_ROW(state, index) {
      let removeIndex = state.brokerCommissionsList.map(function(item) { return item.id; }).indexOf(index);
      state.brokerCommissionsList.splice(removeIndex, 1);
    },
  },
  actions: {
    deleteRow({commit}, dispatch_data) {
      commit('REMOVE_ROW', dispatch_data.id)
    },
  }
}
